import React, { useEffect, useState } from "react"
import { Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"

import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Modal from "@mui/material/Modal"
import TextField from "@mui/material/TextField"
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import Select from "@mui/material/Select"
import AddIcon from "@mui/icons-material/Add"
import { toast } from "react-toastify"
import { useMutation, useQuery } from "react-query"
import { deletePlanModuleFn, getPlanModuleFn, patchPlanModuleFn, postPlanModuleFn } from "Services/Plan Management"
import { useDebouncedQueryValue } from "Hooks/useDebouncedQueryValue"
import axios from "axios"
import { imageURL } from "Config/endpoints"
import { deleteD_leadFn, getCategoryFn, getD_leadFn, patchD_leadFn, postD_leadFn } from "Services/LeadManagement"
import CustomSelect from "Shared/CustomSelect"
import { useFormik } from "formik"
import { Category } from "@mui/icons-material"
import SearchAndSelect from "Shared/CustomSearchAndSelect"
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    rounded: 2,
}
const DiractLeadManagement = () => {

    const [open, setOpen] = React.useState(false)
    const [page, setPage] = useState(1)
    const [searchQuery, setSearchQuery] = useState("")
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPage, setTotalPage] = useState(null)
    const [title, setTitle] = useState("")
    const [image, setImage] = useState(null)
    const [planId, setPlanId] = useState("")
    const [planData, setPlanData] = useState([])
    const [ids, setIds] = useState(null)
    const [rowData, setRowData] = useState({})
    const [description, setDescription] = useState("")
    const [searchValue, setSearchValue] = useState("")
    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)
    const previousData = () => {
        if (page > 1) {
            setPage(page - 1)
        }
    }
    const nextData = () => {
        if (page < totalPage) {
            setPage(page + 1)
        }
    }


    const debouncedSearch = useDebouncedQueryValue(searchQuery, 500);


    const { data, refetch } = useQuery(["D_lead_list", debouncedSearch, page], () => getD_leadFn({
        search: debouncedSearch
    }))


    const LeadData = data?.data?.data



    console.log(searchValue)

    const { data: C, } = useQuery(["Category_list", searchValue], () => getCategoryFn({ search: searchValue }))


    const CategoryList = C?.data?.data?.subsubcategories







    const initialValues = {
        direct_lead_id: rowData?.id,
        category: rowData?.category_id || "",
        quantity: rowData?.quantity || null,
        interested_product: rowData?.interested_product || "",
        additional_requirement: rowData?.additional_requirement || ""

    }




    const { mutate: AddLead } = useMutation(postD_leadFn, {
        onSuccess: (response) => {

            if (response.data.response_code === 200) {

                toast.success(response.data.message)

                handleCloseModal()
            }

            else {
                toast.warn(response.data.message)


            }
        }
    })




    const { mutate: UpdateLead } = useMutation(patchD_leadFn, {
        onSuccess: (response) => {

            if (response.data.response_code === 200) {

                toast.success(response.data.message)

                handleCloseModal()
            }

            else {
                toast.warn(response.data.message)


            }
        }
    })


    const { mutate: DeleteModule } = useMutation(deleteD_leadFn, {
        onSuccess: (response) => {

            if (response.data.response_code === 200) {

                toast.success(response.data.message)
                refetch()




            }

            else {
                toast.warn(response.data.message)


            }
        }
    })


    const formik = useFormik(

        {
            initialValues: initialValues,
            enableReinitialize: true,
            onSubmit: (values) => {

                !rowData?.id ? AddLead(values) : UpdateLead(values)


            }
        }
    )





    const handleCloseModal = () => {
        refetch()

        setRowData({})

        formik.handleReset()

        handleClose()
    }

    // const submitData = () => {
    //     const fd = new FormData()

    //     if (image) {
    //         fd.append("image", image)
    //     }
    //     fd.append("description", description)
    //     fd.append("name", title)
    //     fd.append("planmodule_id", ids)

    //     ids === null
    //         ? AddModule(fd)
    //         : UpdateModule(fd)
    // }

    const editFunction = (row) => {

        setRowData(row)

        handleOpen()
    }

    // plan-type-list-without-pagination-api-for-superadmin

    return (
        <div className=" !bg-slate-100">
            <div className="flex justify-between">
                <div className="p-2">
                    <p className="text-xl !text-black font font-bold">Direct Lead Management List</p>
                </div>
                <div className="p-2 pt-5">
                    <Button variant="outlined" color="primary" onClick={handleOpen}>
                        <AddIcon />
                        Add Lead
                    </Button>
                </div>
            </div>
            <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
                <div className="flex items-center justify-between my-2">
                    <span className="flex  gap-3">
                        <input
                            class="placeholder:italic placeholder:text-slate-400 block mx-3 bg-white w-80 border border-slate-300 rounded-md py-2 px-2 pr-3 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 sm:text-sm"
                            placeholder="Search for anything..."
                            type="text"
                            value={searchQuery}
                            onChange={(event) => setSearchQuery(event.target.value)}
                        />
                    </span>
                    <span>
                        {/* Add Category Bussiness start */}

                        <div className="text-red-500 mx-3">
                            <Modal
                                open={open}
                                onClose={handleCloseModal}
                                aria-labelledby="child-modal-title"
                                aria-describedby="child-modal-description"
                            >
                                <Box sx={{ ...style, width: 600 }} className="rounded-2xl !border-0 !shadow-sm !shadow-blue-900">
                                    <form onSubmit={formik.handleSubmit} className=" w-full">
                                        <div
                                            id="child-modal-title "
                                            className="!text-black !underline !underline-offset-2  !font-bold pb-3 !text-center !text-xl"
                                        >
                                            {!rowData?.id ? "Add Lead" : "Update Lead"}
                                        </div>
                                        <div className="">

                                            {/* <CustomSelect className="" fullWidth label="Category" id="category" formik={formik} placeholder="Select Category">
                                                {CategoryList?.map((i) => (


                                                    <MenuItem value={i?.id}>{i.title}</MenuItem>
                                                ))}

                                            </CustomSelect> */}

                                            <SearchAndSelect
                                                formik={formik}
                                                name="category"
                                                id="category"
                                                setChanges={setSearchValue}
                                                label={"Category"}
                                                options={CategoryList?.map((cat) => ({
                                                    label: cat?.title,
                                                    value: cat?.id,
                                                }))}
                                            />




                                            <div className="mt-2">Quantity </div>
                                            <TextField
                                                value={formik.values.quantity}
                                                id="quantity"
                                                type="number"
                                                onChange={formik.handleChange}

                                                placeholder="Enter Quantity"
                                                size="small"
                                                className="!w-[100%] !m-1"
                                            />

                                            <div className="mt-2">Interested Product </div>
                                            <TextField
                                                value={formik.values.interested_product}
                                                id="interested_product"
                                                onChange={formik.handleChange}

                                                placeholder="Interested Product"
                                                size="small"
                                                className="!w-[100%] !m-1"
                                            />

                                            <div className="mt-2">Additional Requirement</div>
                                            <TextField

                                                type="text"
                                                value={formik.values.additional_requirement
                                                }
                                                id="additional_requirement"
                                                onChange={formik.handleChange}

                                                placeholder="Additional Requirement"
                                                size="small"
                                                className="!w-[100%] !m-1"
                                            />
                                        </div>
                                        <br />
                                        <Button onClick={handleCloseModal} variant="contained" color="warning" className="!py-2">
                                            CANCEL
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            type="submit"
                                            className="!py-2 !px-5 !font-bold !float-right"
                                        // onClick={submitData}
                                        >
                                            {!rowData?.id ? "Add" : "UPDATE"}
                                        </Button>
                                    </form>
                                </Box>
                            </Modal>
                        </div>
                    </span>
                </div>
                <TableContainer
                    component={Paper}
                    sx={{ width: "100%", maxHeight: 440 }}
                    className="!text-black !mx-auto !bg-white overflow-auto px-2"
                >
                    <Table stickyHeader aria-label="sticky table" size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    SR. No.
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Category
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Quantity
                                </TableCell>


                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Interested Product
                                </TableCell>


                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Additional Requirement
                                </TableCell>
                                <TableCell
                                    style={{
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    ACTION
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className="!bg-red">
                            {LeadData &&
                                LeadData?.map((row, index) => (
                                    <TableRow key={row.id} className="!text-slate-700">
                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {index + 1}
                                        </TableCell>
                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {row?.category_name
                                                ? row?.category_name
                                                : "--"}
                                        </TableCell>
                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {row?.quantity ? row?.quantity : "--"}
                                        </TableCell>



                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {row?.interested_product || "--"}

                                        </TableCell>


                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {row?.additional_requirement
                                                || "--"}

                                        </TableCell>
                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            <DeleteIcon onClick={() => DeleteModule({ direct_lead_id: row?.id })} className="!text-xl !text-red-600 !cursor-pointer" />
                                            <EditIcon
                                                className="!text-xl !cursor-pointer !text-green-600"
                                                onClick={() => editFunction(row)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div
                    className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400  flex !flex-col !justify-end !items-end"
                    style={{ marginRight: "0px" }}
                >


                    <Pagination count={data?.data?.total_pages} value={data?.data?.current_page} onChange={(_, value) => setPage(value)} variant="outlined" shape="rounded" />
                    {/* <button onClick={nextData} className="!float-right">
            {data?.data?.current_page}...{data?.data?.total_pages}
            <ArrowForwardIosIcon />
          </button>
          <button onClick={previousData} className="float-right">
            <ArrowBackIosIcon />
          </button> */}
                </div>
            </div>
        </div>
    )
}

export default DiractLeadManagement
